/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import styles from './CustomerInfo.module.scss';

const CustomerInfo = () => {
  const customer = useSelector((state) => state.customer ? state.customer : {});

  let nameMarkup = null;
  if(!_.isEmpty((customer.fullName))) {
    nameMarkup = <span className={`${styles["name"]} blocked_data`}>{ customer.fullName }</span>;
  }
  return (
    <div id="customer-info" className={`${styles["customer-info"]}`}>
      <span className={`${styles["title"]}`}>Your Required Minimum Distribution (RMD)</span>
      <div className="blocked_data">
        {nameMarkup}
      </div>
    </div>
  );
};

CustomerInfo.propTypes = {
  customer: PropTypes.object
};

export default CustomerInfo;